// extracted by mini-css-extract-plugin
export default {"contactContent":"contact_contactContent__eyVNQ","formContainer":"contact_formContainer__-iF5U","socialLinks":"contact_socialLinks__yEcJo","icons":"contact_icons__NPcRA"};